import React, { lazy } from 'react';
import HippyApiIcon from '@/assets/images/menu/icon-hippy-api.react.svg?react';
import HippyErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import HippyEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import HippyLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import HippyPerfIcon from '@/assets/images/menu/icon-hippy-perf.react.svg?react';
import HippyPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import HippySpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';


export const kuiklyRoutes = (): IRouteConfig[] => [
  {
    path: '/kuikly/error',
    name: '错误监控',
    component: lazy(() => import('@/presentation/pages/kuikly/error')),
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyErrorIcon} />,
  },
  {
    path: '/kuikly/detail',
    name: '错误监控详情',
    component: lazy(() => import('@/presentation/pages/kuikly/error/kotlin-anomalies/detail/index')),
    hideInMenu: true,
    whitelisted: true,
  },
  {
    path: '/kuikly/api',
    name: 'API监控',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyApiIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/api')),
  },
  {
    path: '/kuikly/perf',
    name: '页面性能',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyPerfIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/perf')),
  },
  {
    path: '/kuikly/pv',
    name: '页面访问',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyPvIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/pv')),
  },
  {
    path: '/kuikly/event',
    name: '自定义事件',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyEventIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/event')),
  },
  {
    path: '/kuikly/custom',
    name: '自定义测速',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippySpeedIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/custom')),
  },
  {
    path: '/kuikly/log',
    name: '日志',
    platforms: [CapitalPlatform.Kuikly],
    icon: <MenuIcon icon={HippyLogIcon} />,
    component: lazy(() => import('@/presentation/pages/kuikly/log')),
  },
];

export default kuiklyRoutes;
